class SettingsTime {
    static value = [{ Text: '今天', Value: 0 }, { Text: '最近三天', Value: 2 }, { Text: '最近七天', Value: 3 }]
}
class SettingsTimes {
    static value = [{ Text: '今天', Value: 0 }, { Text: '最近三天', Value: 2 }]
}
class SettingspatientType {
    static value = [{ Text: '患者来源', Value: 0 }, { Text: '门诊', Value: 1 }, { Text: '住院', Value: 2 }, { Text: '体检', Value: 3 }, { Text: '筛查', Value: 4 }]
}
class SettingsqueryType {
    static value = [{ Text: '检查号', Value: 0 }, { Text: '姓名', Value: 1 }]
}

export default {
  SettingsTime,
  SettingspatientType,
  SettingsqueryType,
  SettingsTimes
}
